import styled from 'styled-components';
import MySafetySvg from '../../assets/hotels/mysafety-active.svg';

const MySafetyActive = styled(MySafetySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4rem'};
  height: ${props => props.height || '4rem'};
  margin: ${props => props.margin};
`;

export default MySafetyActive;
